<mat-card>
  <mat-card-header *ngIf="!camera.isLive && !camera.isRestricted; else stream">
    <sn-icon matCardAvatar>videocam</sn-icon>
    <mat-card-title class="fs-text-truncate">{{ camera.name }}</mat-card-title>
    <mat-card-subtitle class="fs-text-truncate" *ngIf="camera.location">{{
      camera.location.name
    }}</mat-card-subtitle>
  </mat-card-header>
  <ng-template #stream>
    <sn-audit-camera-stream-view
      matCardImage
      [camera]="camera"
      [controls]="true"
      [autoplay]="autoplay"
    >
    </sn-audit-camera-stream-view>
  </ng-template>
</mat-card>
